import axios from 'axios'
import Cookies from 'js-cookie';
import { Message } from 'element-ui';
import { getCache, clearCache, setCache } from '@/utils'
import router from '@/router'

class Request {
    constructor() {
        this.config = {
            baseURL: "/",
            timeout: 600000,
            headers: {
                "content-type": "application/json",
            }
        }
        this.instance = axios.create(this.config)

        // 添加请求拦截器
        this.instance.interceptors.request.use(function (config) {
            config.headers['token'] = 'Bearer ' + getCache('xczn_admin_token')
            config.headers['x-csrf-token'] = Cookies.get('csrfToken')
            // 在发送请求之前做些什么
            return config;
        }, function (error) {
            // 对请求错误做些什么
            return Promise.reject(error);
        });

        // 添加响应拦截器
        this.instance.interceptors.response.use(function (response) {

            const newToken = response.headers['x-new-token'];
            if (newToken) {
                setCache('xczn_admin_token', newToken);
            }
            // 对响应数据做点什么
            const { code, msg } = response.data
            switch (code) {
                case 0:
                    return response
                case 400:
                case 401:
                    clearCache('xczn_admin_token')
                    clearCache('xczn_admin_nickname')
                    Message({
                        message: msg,
                        type: 'error',
                        duration: 2500,
                        onClose: () => {
                            router.push({path:"/login"})
                        }
                    })
                    return Promise.reject(response)
                default:
                    Message({ message: msg, type: 'error' })
                    return Promise.reject(response)
            }
            //return response;
        }, function (error) {
            // 对响应错误做点什么
            return Promise.reject(error);
        });
    }
    post(url, data, headers = {}) {
        return new Promise((resolve, reject) => {
            this.instance.request({
                method: "post",
                url,
                data,
                headers
            }).then((res) => {
                if (headers?.delay && headers.delay) {
                    setTimeout(() => {
                        resolve(res.data)
                    }, headers.delay);
                } else {
                    resolve(res.data)
                }
            })
            .catch((err) => {
                reject(err)
            })
        })
    }

    get(url, params, headers = {}) {
        return new Promise((resolve, reject) => {
            this.instance.request({
                method: "get",
                url,
                params,
                headers
            }).then((res) => {
                resolve(res.data)
            }).catch((err) => {
                reject(err)
            })
        })
    }
    uploadFile(url, data, callBack) {
        return new Promise((resolve, reject) => {
            this.instance.request({
                method: "post",
                url,
                data,
                headers: { 'Content-Type': 'multipart/form-data' },
                onUploadProgress: (progressEvent) => {
                    let loaded = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                    callBack(loaded)
                }
            }).then((res) => {
                resolve(res.data)
            }).catch((err) => {
                reject(err)
            })
        })
    }

    uploadPutFile(url, data, callBack,content_type) {
        let contentType = 'multipart/form-data'
        if(content_type){
            contentType = content_type
        }        
        return new Promise((resolve, reject) => {
            const instance = axios.create({ timeout: 600000})
            instance.request({
                method: "put",
                url,
                data,
                headers: { 'Content-Type': contentType },
                onUploadProgress: (progressEvent) => {
                    let loaded = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                    callBack(loaded)
                }
            }).then((res) => {
                resolve(res.data)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default new Request()


// WEBPACK FOOTER //
// ./src/api/base.js